import { Outlet } from "react-router-dom";
import style from "./MainAdminLayout.module.scss";
import { Footer, Header, Menu } from "../components";
import { MenuLink } from "layout/components/Menu/components";
import { useAdminLogoutMutation } from "@RTKQuery/admin/auth/auth";

export function MainAdminLayout() {
  const [adminLogout] = useAdminLogoutMutation();

  return (
    <div id="layout" className={style.layout}>
      <div  className={style.zoom}>
        <Header />
        <div id="zoom" className={style.flexBox}>
          <Menu
            linksGroups={[
              {
                nameGroup: "Меню",
                links: [
                  <MenuLink
                    link={(process.env.NODE_ENV === "production" ? "/" : "/admin")} 
                    key={0}
                    label="Мої Проксі"
                    icon={
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                      >
                        <path
                          d="M13.7497 3.66667H16.4997C16.7428 3.66667 16.9759 3.76324 17.1479 3.93515C17.3198 4.10706 17.4163 4.34022 17.4163 4.58333V18.3333C17.4163 18.5764 17.3198 18.8096 17.1479 18.9815C16.9759 19.1534 16.7428 19.25 16.4997 19.25H5.49967C5.25656 19.25 5.0234 19.1534 4.85149 18.9815C4.67959 18.8096 4.58301 18.5764 4.58301 18.3333V4.58333C4.58301 4.34022 4.67959 4.10706 4.85149 3.93515C5.0234 3.76324 5.25656 3.66667 5.49967 3.66667H8.24968M8.24968 6.41667H13.7497M8.24968 11H13.7497M8.24968 14.6667H13.7497M9.16634 2.75V6.41667H12.833V2.75H9.16634Z"
                          stroke="#D4EAFF"
                          strokeWidth="1.83333"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    }
                  />,
                  <MenuLink
                    link={(process.env.NODE_ENV === "production" ? "" : "/admin") +"/statistics?tab=dashboard"} 
                    key={1}
                    label="Статистика"
                    icon={
                      <svg
                        className={style.fill}
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                      >
                        <path
                          d="M19 2H3C2.20435 2 1.44129 2.31607 0.87868 2.87868C0.31607 3.44129 0 4.20435 0 5V17C0 17.7956 0.31607 18.5587 0.87868 19.1213C1.44129 19.6839 2.20435 20 3 20H19C19.7956 20 20.5587 19.6839 21.1213 19.1213C21.6839 18.5587 22 17.7956 22 17V5C22 4.20435 21.6839 3.44129 21.1213 2.87868C20.5587 2.31607 19.7956 2 19 2ZM20 17C20 17.2652 19.8946 17.5196 19.7071 17.7071C19.5196 17.8946 19.2652 18 19 18H3C2.73478 18 2.48043 17.8946 2.29289 17.7071C2.10536 17.5196 2 17.2652 2 17V5C2 4.73478 2.10536 4.48043 2.29289 4.29289C2.48043 4.10536 2.73478 4 3 4H19C19.2652 4 19.5196 4.10536 19.7071 4.29289C19.8946 4.48043 20 4.73478 20 5V17ZM8 11V15C8 15.2652 7.89464 15.5196 7.70711 15.7071C7.51957 15.8946 7.26522 16 7 16C6.73478 16 6.48043 15.8946 6.29289 15.7071C6.10536 15.5196 6 15.2652 6 15V11C6 10.7348 6.10536 10.4804 6.29289 10.2929C6.48043 10.1054 6.73478 10 7 10C7.26522 10 7.51957 10.1054 7.70711 10.2929C7.89464 10.4804 8 10.7348 8 11ZM12 9V15C12 15.2652 11.8946 15.5196 11.7071 15.7071C11.5196 15.8946 11.2652 16 11 16C10.7348 16 10.4804 15.8946 10.2929 15.7071C10.1054 15.5196 10 15.2652 10 15V9C10 8.73478 10.1054 8.48043 10.2929 8.29289C10.4804 8.10536 10.7348 8 11 8C11.2652 8 11.5196 8.10536 11.7071 8.29289C11.8946 8.48043 12 8.73478 12 9ZM16 7V15C16 15.2652 15.8946 15.5196 15.7071 15.7071C15.5196 15.8946 15.2652 16 15 16C14.7348 16 14.4804 15.8946 14.2929 15.7071C14.1054 15.5196 14 15.2652 14 15V7C14 6.73478 14.1054 6.48043 14.2929 6.29289C14.4804 6.10536 14.7348 6 15 6C15.2652 6 15.5196 6.10536 15.7071 6.29289C15.8946 6.48043 16 6.73478 16 7Z"
                          fill="currentColor"
                        />
                      </svg>
                    }
                  />,
                  <MenuLink
                    link={(process.env.NODE_ENV === "production" ? "" : "/admin") +"/customers"} 
                    key={2}
                    label="Клієнти"
                    icon={
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                      >
                        <path
                          d="M5 17.625V16.5C5 15.6049 5.35558 14.7464 5.98851 14.1135C6.62145 13.4806 7.47989 13.125 8.375 13.125H12.875C13.7701 13.125 14.6286 13.4806 15.2615 14.1135C15.8944 14.7464 16.25 15.6049 16.25 16.5V17.625C16.25 17.9234 16.1315 18.2095 15.9205 18.4205C15.7095 18.6315 15.4234 18.75 15.125 18.75H6.125C5.82663 18.75 5.54048 18.6315 5.32951 18.4205C5.11853 18.2095 5 17.9234 5 17.625ZM14 6.375C14 7.27011 13.6444 8.12855 13.0115 8.76149C12.3786 9.39442 11.5201 9.75 10.625 9.75C9.72989 9.75 8.87145 9.39442 8.23851 8.76149C7.60558 8.12855 7.25 7.27011 7.25 6.375C7.25 5.47989 7.60558 4.62145 8.23851 3.98851C8.87145 3.35558 9.72989 3 10.625 3C11.5201 3 12.3786 3.35558 13.0115 3.98851C13.6444 4.62145 14 5.47989 14 6.375Z"
                          stroke="#D4EAFF"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    }
                  />
                ]
              },
              {
                nameGroup: "Інше",
                links: [
                  <MenuLink
                    link={(process.env.NODE_ENV === "production" ? "" : "/admin") +"/settings?tab=promo_codes"} 
                    key={0}
                    label="Налаштування"
                    icon={
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                      >
                        <path
                          d="M20 12V10C20 9.73478 19.8946 9.48043 19.7071 9.29289C19.5196 9.10536 19.2652 9 19 9H18.243L17.536 7.293L18.071 6.757C18.2585 6.56947 18.3638 6.31516 18.3638 6.05C18.3638 5.78484 18.2585 5.53053 18.071 5.343L16.657 3.929C16.4695 3.74153 16.2152 3.63621 15.95 3.63621C15.6848 3.63621 15.4305 3.74153 15.243 3.929L14.707 4.464L13 3.757V3C13 2.73478 12.8946 2.48043 12.7071 2.29289C12.5196 2.10536 12.2652 2 12 2H10C9.73478 2 9.48043 2.10536 9.29289 2.29289C9.10536 2.48043 9 2.73478 9 3V3.757L7.293 4.464L6.757 3.929C6.56947 3.74153 6.31516 3.63621 6.05 3.63621C5.78484 3.63621 5.53053 3.74153 5.343 3.929L3.929 5.343C3.74153 5.53053 3.63621 5.78484 3.63621 6.05C3.63621 6.31516 3.74153 6.56947 3.929 6.757L4.465 7.293L3.757 9H3C2.73478 9 2.48043 9.10536 2.29289 9.29289C2.10536 9.48043 2 9.73478 2 10V12C2 12.2652 2.10536 12.5196 2.29289 12.7071C2.48043 12.8946 2.73478 13 3 13H3.757L4.464 14.707L3.929 15.243C3.74153 15.4305 3.63621 15.6848 3.63621 15.95C3.63621 16.2152 3.74153 16.4695 3.929 16.657L5.343 18.071C5.53053 18.2585 5.78484 18.3638 6.05 18.3638C6.31516 18.3638 6.56947 18.2585 6.757 18.071L7.293 17.536L9 18.243V19C9 19.2652 9.10536 19.5196 9.29289 19.7071C9.48043 19.8946 9.73478 20 10 20H12C12.2652 20 12.5196 19.8946 12.7071 19.7071C12.8946 19.5196 13 19.2652 13 19V18.243L14.707 17.535L15.243 18.071C15.4305 18.2585 15.6848 18.3638 15.95 18.3638C16.2152 18.3638 16.4695 18.2585 16.657 18.071L18.071 16.657C18.2585 16.4695 18.3638 16.2152 18.3638 15.95C18.3638 15.6848 18.2585 15.4305 18.071 15.243L17.536 14.707L18.243 13H19C19.2652 13 19.5196 12.8946 19.7071 12.7071C19.8946 12.5196 20 12.2652 20 12Z"
                          stroke="#D4EAFF"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M11 14C11.7956 14 12.5587 13.6839 13.1213 13.1213C13.6839 12.5587 14 11.7956 14 11C14 10.2044 13.6839 9.44129 13.1213 8.87868C12.5587 8.31607 11.7956 8 11 8C10.2044 8 9.44129 8.31607 8.87868 8.87868C8.31607 9.44129 8 10.2044 8 11C8 11.7956 8.31607 12.5587 8.87868 13.1213C9.44129 13.6839 10.2044 14 11 14Z"
                          stroke="#D4EAFF"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    }
                  />,
                  <MenuLink
                    onClick={() => {
                      adminLogout()
                    }}
                    key={5}
                    label="Вихід"
                    icon={
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                      >
                        <path
                          d="M17.4998 14L20.9998 11M20.9998 11L17.4998 8M20.9998 11H8.99976M14.3748 5.65466V5.60022C14.3748 4.3401 14.3748 3.70957 14.1295 3.22828C13.9138 2.8049 13.5699 2.46095 13.1465 2.24524C12.6652 2 12.0346 2 10.7745 2H5.59953C4.33942 2 3.71021 2 3.22893 2.24524C2.80559 2.46095 2.46044 2.8049 2.24478 3.22828C1.99976 3.7091 1.99976 4.33886 1.99976 5.59652V16.4041C1.99976 17.6617 1.99976 18.2906 2.24478 18.7714C2.46044 19.1947 2.80559 19.5393 3.22893 19.755C3.70976 20 4.33863 20 5.59627 20H10.7782C12.0359 20 12.6657 20 13.1465 19.755C13.5699 19.5393 13.9138 19.1944 14.1295 18.771C14.3748 18.2898 14.3748 17.6601 14.3748 16.4V16.3438"
                          stroke="#D4EAFF"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    }
                  />
                ]
              }
            ]}
          />
          <Outlet />
        </div>
        <Footer />
      </div>
    </div>
  );
}
